"use client";

import {
  NewsContext,
  newsContextSchema,
} from "@vereinsheim/backend-types/src/news";
import Link from "next/link";
import { pwaOvNewsListPath, pwaOvNewsTeamListPath } from "@/utils/urlHelper";
import { NoContentPlain } from "../../components/NoContent";
import { OvNews } from "@/sources/kicker-ovsyndication";
import { OvNewsElement } from "./OvNewsElement";

type OvNewsListProps = {
  newsList: OvNews[];
  displayAmount?: number;
  contextId: string;
  newsContext: NewsContext;
};

export function OvNewsList({
  newsList,
  displayAmount,
  contextId,
  newsContext,
}: OvNewsListProps) {
  return (
    <div className="px-4">
      {newsList.length > 0 ? (
        newsList
          .slice(0, displayAmount ?? 50)
          .map((n) => (
            <div key={`div-news-${n.id}`} className="border-t border-gray-150 first:border-t-0 py-2">
              <OvNewsElement
                listContext={newsContext}
                contextId={contextId}
                news={n}
                className="p-2 -mx-2"
                key={n.id}
              />

            </div>
          ))
      ) : (
        <NoContentPlain className="flex-col">
          Keine News gefunden.
          <br />
        </NoContentPlain>
      )}
      {displayAmount && newsList.length > displayAmount && (
        <div className="border-t border-gray-150">
          <Link
            className="button button--link-secondary w-full justify-center"
            href={
              newsContext == newsContextSchema.enum.Team
                ? pwaOvNewsTeamListPath(contextId)
                : pwaOvNewsListPath()
            }
          >
            {newsContext === newsContextSchema.enum.Team
              ? "Alle kicker Amateurnews anzeigen"
              : "Alle kicker Amateurnews anzeigen"}
          </Link>
        </div>
      )}
    </div>
  );
}
